<template>
  <div
    class="apex-table"
    :class="{ 'table-header-bgc': headerBgc }"
    :element-loading-text="loadingOptions ? handleAttribute(loadingOptions.text, null) : null"
    :element-loading-spinner="loadingOptions ? handleAttribute(loadingOptions.spinner, null) : null"
    :element-loading-background="loadingOptions ? handleAttribute(loadingOptions.background, null) : null"
  >
    <div v-if="headerOperations.length || toolbar" class="apex-table-header">
      <div class="operations">
        <template v-for="(item, index) in headerOperations">
          <el-button
            v-if="toolbarButtonShow(item.show) && !item.slotName"
            :key="index"
            :disabled="toolbarButtonDisabled(item.disabled)"
            v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item) : item"
            @click="$emit(item.emit)"
          >
            {{ item.text }}
          </el-button>
          <slot v-if="item.slotName" :name="item.slotName" />
        </template>
        <slot name="headerOperationSlot" />
      </div>
      <div v-if="toolbar" class="toolbar">
        <apex-toolbar
          ref="apexToolbar"
          v-bind="toolbar"
          :columns="columns"
          :selection-rows="selectionRows"
          :advanced-search-expanded="advancedSearchExpanded"
          @reset="reset"
          @refresh="refresh"
          @exportExcel="exportExcel"
          @columns-filter-changed="handleColumnsFilterChanged"
          @comb-sort-change="handleCombSortChange"
          @color-change="colorChange"
          @handleToolbarEmit="handleToolbarEmit"
          @handleAdvancedSearchExpanded="handleAdvancedSearchExpanded"
        >
          <slot name="toolbarSlot" />
        </apex-toolbar>
      </div>
    </div>
    <div v-if="toolbar && toolbar.advancedSearch" class="apex-advanced-search">
      <advanced-search
        v-show="advancedSearchExpanded"
        ref="refAdvancedSearch"
        :advanced-search-expanded="advancedSearchExpanded"
        :operator-list="toolbar.advancedSearch.operatorList"
        :and-or-list="toolbar.advancedSearch.andOrList"
        @expandChange="handleAdvancedSearchExpanded"
        @deleteTemplate="advancedSearchDeleteTemplate"
        @saveTemplate="advancedSearchSaveTemplate"
        @search="advancedSearch"
        @reset="advancedSearchReset"
        @clickTemplate="advancedSearchClickTemplate"
        @setAsDefaultTemplate="advancedSearchSetAsDefaultTemplate"
        @fieldChange="advancedSearchFieldChange"
      />
    </div>
    <div class="apex-table-body">
      <el-table
        ref="elTable"
        v-loading="loading"
        :data="apexTableData"
        v-bind="options"
        :border="options && options.border !== undefined ? options.border : true"
        :highlight-current-row="(options && options.highlightCurrentRow) || (!!radioRow || radioRow === '')"
        :height="adaptive ? '100%' : options && options.height"
        :row-style="tableRowStyle"
        :row-class-name="tableRowClassName"
        @select="handleSelect"
        @select-all="handleSelectAll"
        @selection-change="handleSelectionChange"
        @cell-mouse-enter="handleCellMouseEnter"
        @cell-mouse-leave="handleCellMouseLeave"
        @cell-click="handleCellClick"
        @cell-dblclick="handleCellDblclick"
        @row-click="handleRowClick"
        @row-contextmenu="handleRowContextmenu"
        @row-dblclick="handleRowDblclick"
        @header-click="handleHeaderClick"
        @header-contextmenu="handleHeaderContextmenu"
        @sort-change="handleSortChange"
        @filter-change="handleFilterChange"
        @current-change="handleCurrentChange"
        @header-dragend="handleHeaderDragend"
        @expand-change="handleExpandChange"
      >
        <div slot="append">
          <slot name="append" />
        </div>
        <el-table-column
          v-if="!!radioRow || radioRow === ''"
          :width="radioRow.width || '50px'"
          :align="radioRow.align || 'center'"
          v-bind="radioRow"
        >
          <template slot-scope="scope">
            <el-radio v-model="tempRadioId" :label="scope.$index" />
          </template>
        </el-table-column>
        <el-table-column
          v-if="(selectionRow || selectionRow === '') && !selectionRow.hidden"
          type="selection"
          :width="selectionRow.width || '50px'"
          :align="selectionRow.align || 'center'"
          v-bind="selectionRow"
        />
        <el-table-column
          v-if="indexRow || indexRow === ''"
          type="index"
          :label="handleAttribute(indexRow.title, '')"
          :width="indexRow.width || '50px'"
          :align="indexRow.align || 'center'"
          :index="indexRow.index || continuousIndexMethod"
          v-bind="indexRow"
        />
        <el-table-column
          v-for="(item, index) in columnsFilter"
          :key="`${index}_${item.key}`"
          :label="handleAttribute(item.title, '')"
          :prop="handleAttribute(item.key, null)"
          v-bind="item"
        >
          <template slot="header" slot-scope="scope">
            <span v-if="!(item.filterColumn && item.filterColumn.showTitle === false)">{{ handleAttribute(item.title, "") }}</span>
            <el-input
              v-if="item.filterColumn && item.filterColumn.name === 'el-input'"
              v-model="filterColumnObj[item.filterColumn.keys ? item.filterColumn.keys[0] : item.key]"
              v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item.filterColumn) : item.filterColumn"
              :placeholder="item.filterColumn.placeholder || 'filter column'"
              :clearable="item.filterColumn.clearable === false ? item.filterColumn.clearable : true"
              @click.native="e => e.stopPropagation()"
              @input="filterColumn(item.filterColumn.customMethod, item.key, ...arguments, item.filterColumn.isRemote)"
              @keyup.enter.native="remoteColumn(item.key, filterColumnObj[item.filterColumn.keys ? item.filterColumn.keys[0] : item.key])"
            />
            <el-select
              v-else-if="item.filterColumn && item.filterColumn.name === 'el-select'"
              v-model="filterColumnObj[item.filterColumn.keys ? item.filterColumn.keys[0] : item.key]"
              v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item.filterColumn) : item.filterColumn"
              :placeholder="item.filterColumn.placeholder || 'filter column'"
              :clearable="item.filterColumn.clearable === false ? item.filterColumn.clearable : true"
              @click.native="e => e.stopPropagation()"
              @change="filterColumnChange(item, ...arguments)"
            >
              <el-option v-for="option in handleList(item.filterColumn.options)" :key="option.value" v-bind="option" />
            </el-select>
            <apex-select
              v-else-if="item.filterColumn && item.filterColumn.name === 'apex-select'"
              v-model="filterColumnObj[item.filterColumn.keys ? item.filterColumn.keys[0] : item.key]"
              v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item.filterColumn) : item.filterColumn"
              :options="handleList(item.filterColumn.options)"
              :placeholder="item.filterColumn.placeholder || 'filter column'"
              @click.native="e => e.stopPropagation()"
              @change="filterColumnChange(item, ...arguments)"
            />
            <apex-date-picker
              v-else-if="item.filterColumn && item.filterColumn.name === 'el-date-picker'"
              v-model="filterColumnObj[item.filterColumn.keys ? item.filterColumn.keys[0] : item.key]"
              v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item.filterColumn) : item.filterColumn"
              :placeholder="item.filterColumn.placeholder || 'filter column'"
              @click.native="e => e.stopPropagation()"
              @change="filterColumnChange(item, ...arguments)"
              @blur="remoteColumn(item.key, filterColumnObj[item.filterColumn.keys ? item.filterColumn.keys[0] : item.key])"
            />
            <div v-else-if="item.filterColumn && item.filterColumn.name === 'begin-end-date'" class="apex-table-header-begin-end-date">
              <apex-date-picker
                v-model="filterColumnObj[item.filterColumn.keys[0]]"
                v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item.filterColumn) : item.filterColumn"
                :placeholder="item.filterColumn.placeholder || 'Begin date'"
                :picker-options="{ disabledDate: time => beginDateFn(time, filterColumnObj[item.filterColumn.keys[1]]) }"
                @click.native="e => e.stopPropagation()"
                @change="filterColumnChange(item, ...arguments)"
              />
              <span>-</span>
              <apex-date-picker
                v-model="filterColumnObj[item.filterColumn.keys[1]]"
                v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item.filterColumn) : item.filterColumn"
                :placeholder="item.filterColumn.placeholder || 'End date'"
                :picker-options="{ disabledDate: time => endDateFn(time, filterColumnObj[item.filterColumn.keys[0]]) }"
                @click.native="e => e.stopPropagation()"
                @change="filterColumnChange(item, ...arguments)"
              />
            </div>
            <!-- 具名slot -->
            <slot v-else-if="item.filterColumn && item.filterColumn.slotName" :name="item.filterColumn && item.filterColumn.slotName" :scope="{ filterColumnObj, filterColumn: item.filterColumn, column: scope.column, title: handleAttribute(item.title, '') }" />
          </template>
          <template slot-scope="scope">
            <el-input
              v-if="item.component && item.component.name === 'el-input'"
              v-model="scope.row[item.key]"
              v-only-number="item.component.onlyNumber"
              v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item.component) : item.component"
              @click.native="e => e.stopPropagation()"
              @keyup.enter.native="item.component.keyup && item.component.keyup({ rowIndex: scope.$index, key: item.key, value: scope.row[item.key], row: scope.row })"
              @change="$emit('cell-data-change', { rowIndex: scope.$index, key: item.key, value: scope.row[item.key], row: scope.row })"
            />
            <el-input-number
              v-else-if="item.component && item.component.name === 'el-input-number'"
              v-model="scope.row[item.key]"
              v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item.component) : item.component"
              @click.native="e => e.stopPropagation()"
              @change="$emit('cell-data-change', { rowIndex: scope.$index, key: item.key, value: scope.row[item.key], row: scope.row })"
            />
            <el-radio-group
              v-else-if="item.component && item.component.name === 'el-radio'"
              v-model="scope.row[item.key]"
              v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item.component) : item.component"
              @click.native="e => e.stopPropagation()"
              @change="$emit('cell-data-change', { rowIndex: scope.$index, key: item.key, value: scope.row[item.key], row: scope.row })"
            >
              <template v-if="item.component.buttonMode">
                <el-radio-button v-for="option in item.component.options" :key="option.value" :label="option.value">
                  {{ option.label }}
                </el-radio-button>
              </template>
              <template v-else>
                <el-radio v-for="option in item.component.options" :key="option.value" :label="option.value">
                  {{ option.label }}
                </el-radio>
              </template>
            </el-radio-group>
            <el-checkbox
              v-else-if="item.component && item.component.name === 'el-checkbox'"
              v-model="scope.row[item.key]"
              v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item.component) : item.component"
              @click.native="e => e.stopPropagation()"
              @change="$emit('cell-data-change', { rowIndex: scope.$index, key: item.key, value: scope.row[item.key], row: scope.row })"
            />
            <el-checkbox-group
              v-else-if="item.component && item.component.name === 'el-checkbox-group'"
              v-model="scope.row[item.key]"
              v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item.component) : item.component"
              @click.native="e => e.stopPropagation()"
              @change="$emit('cell-data-change', { rowIndex: scope.$index, key: item.key, value: scope.row[item.key], row: scope.row })"
            >
              <template v-if="item.component.buttonMode">
                <el-checkbox-button v-for="option in item.component.options" :key="option.value" :label="option.value">
                  {{ option.label }}
                </el-checkbox-button>
              </template>
              <template v-else>
                <el-checkbox v-for="option in item.component.options" :key="option.value" :label="option.value">
                  {{ option.label }}
                </el-checkbox>
              </template>
            </el-checkbox-group>
            <el-select
              v-else-if="item.component && item.component.name === 'el-select'"
              v-model="scope.row[item.key]"
              v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item.component) : item.component"
              @click.native="e => e.stopPropagation()"
              @change="$emit('cell-data-change', { rowIndex: scope.$index, key: item.key, value: scope.row[item.key], row: scope.row })"
            >
              <el-option v-for="option in handleList(item.component.options)" :key="option.value" v-bind="option" />
            </el-select>
            <el-cascader
              v-else-if="item.component && item.component.name === 'el-cascader'"
              v-model="scope.row[item.key]"
              v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item.component) : item.component"
              @click.native="e => e.stopPropagation()"
              @change="$emit('cell-data-change', { rowIndex: scope.$index, key: item.key, value: scope.row[item.key], row: scope.row })"
            />
            <el-switch
              v-else-if="item.component && item.component.name === 'el-switch'"
              v-model="scope.row[item.key]"
              v-bind="item.component"
              @click.native="e => e.stopPropagation()"
              @change="$emit('cell-data-change', { rowIndex: scope.$index, key: item.key, value: scope.row[item.key], row: scope.row })"
            />
            <el-slider
              v-else-if="item.component && item.component.name === 'el-slider'"
              v-model="scope.row[item.key]"
              v-bind="item.component"
              @click.native="e => e.stopPropagation()"
              @change="$emit('cell-data-change', { rowIndex: scope.$index, key: item.key, value: scope.row[item.key], row: scope.row })"
            />
            <el-time-select
              v-else-if="item.component && item.component.name === 'el-time-select'"
              v-model="scope.row[item.key]"
              v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item.component) : item.component"
              @click.native="e => e.stopPropagation()"
              @change="$emit('cell-data-change', { rowIndex: scope.$index, key: item.key, value: scope.row[item.key], row: scope.row })"
            />
            <el-time-picker
              v-else-if="item.component && item.component.name === 'el-time-picker'"
              v-model="scope.row[item.key]"
              v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item.component) : item.component"
              @click.native="e => e.stopPropagation()"
              @change="$emit('cell-data-change', { rowIndex: scope.$index, key: item.key, value: scope.row[item.key], row: scope.row })"
            />
            <apex-date-picker
              v-else-if="item.component && item.component.name === 'el-date-picker'"
              v-model="scope.row[item.key]"
              v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item.component) : item.component"
              @click.native="e => e.stopPropagation()"
              @change="$emit('cell-data-change', { rowIndex: scope.$index, key: item.key, value: scope.row[item.key], row: scope.row })"
            />
            <el-rate
              v-else-if="item.component && item.component.name === 'el-rate'"
              v-model="scope.row[item.key]"
              v-bind="item.component"
              @click.native="e => e.stopPropagation()"
              @change="$emit('cell-data-change', { rowIndex: scope.$index, key: item.key, value: scope.row[item.key], row: scope.row })"
            />
            <el-color-picker
              v-else-if="item.component && item.component.name === 'el-color-picker'"
              v-model="scope.row[item.key]"
              v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item.component) : item.component"
              @click.native="e => e.stopPropagation()"
              @change="$emit('cell-data-change', { rowIndex: scope.$index, key: item.key, value: scope.row[item.key], row: scope.row })"
            />
            <render-custom-component
              v-else-if="item.component && item.component.name"
              v-model="scope.row[item.key]"
              :component-name="item.component.name"
              :props="item.component.props ? item.component.props : null"
              :scope="scope"
            />
            <render-component v-else-if="item.component && item.component.render" :render-function="item.component.render" :scope="scope" />
            <!-- 具名slot -->
            <slot v-else-if="item.slotName" :name="item.slotName" :scope="scope" />
            <template v-else-if="item.show !== false">{{
              item.formatter ? item.formatter(scope.row, scope.column, _get(scope.row, item.key), scope.$index) : _get(scope.row, item.key)
            }}</template>
          </template>
          <template v-if="item.children">
            <el-table-column
              v-for="(item2, index2) in item.children"
              :key="index2"
              :label="handleAttribute(item2.title, '')"
              :prop="handleAttribute(item2.key, null)"
              v-bind="item2"
            >
              <template slot-scope="scope">
                <el-input
                  v-if="item2.component && item2.component.name === 'el-input'"
                  v-model="scope.row[item2.key]"
                  v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item2.component) : item2.component"
                  @click.native="e => e.stopPropagation()"
                  @keyup.enter.native="item2.component.keyup && item2.component.keyup({ rowIndex: scope.$index, key: item2.key, value: scope.row[item2.key], row: scope.row })"
                  @change="
                    $emit('cell-data-change', { rowIndex: scope.$index, key: item2.key, value: scope.row[item2.key], row: scope.row })
                  "
                />
                <el-input-number
                  v-else-if="item2.component && item2.component.name === 'el-input-number'"
                  v-model="scope.row[item2.key]"
                  v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item2.component) : item2.component"
                  @click.native="e => e.stopPropagation()"
                  @change="
                    $emit('cell-data-change', { rowIndex: scope.$index, key: item2.key, value: scope.row[item2.key], row: scope.row })
                  "
                />
                <el-radio-group
                  v-else-if="item2.component && item2.component.name === 'el-radio'"
                  v-model="scope.row[item2.key]"
                  v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item2.component) : item2.component"
                  @click.native="e => e.stopPropagation()"
                  @change="
                    $emit('cell-data-change', { rowIndex: scope.$index, key: item2.key, value: scope.row[item2.key], row: scope.row })
                  "
                >
                  <template v-if="item2.component.buttonMode">
                    <el-radio-button v-for="option in item2.component.options" :key="option.value" :label="option.value">
                      {{ option.label }}
                    </el-radio-button>
                  </template>
                  <template v-else>
                    <el-radio v-for="option in item2.component.options" :key="option.value" :label="option.value">
                      {{ option.label }}
                    </el-radio>
                  </template>
                </el-radio-group>
                <el-checkbox
                  v-else-if="item2.component && item2.component.name === 'el-checkbox'"
                  v-model="scope.row[item2.key]"
                  v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item2.component) : item2.component"
                  @click.native="e => e.stopPropagation()"
                  @change="$emit('cell-data-change', { rowIndex: scope.$index, key: item2.key, value: scope.row[item2.key], row: scope.row })"
                />
                <el-checkbox-group
                  v-else-if="item2.component && item2.component.name === 'el-checkbox-group'"
                  v-model="scope.row[item2.key]"
                  v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item2.component) : item2.component"
                  @click.native="e => e.stopPropagation()"
                  @change="
                    $emit('cell-data-change', { rowIndex: scope.$index, key: item2.key, value: scope.row[item2.key], row: scope.row })
                  "
                >
                  <template v-if="item2.component.buttonMode">
                    <el-checkbox-button v-for="option in item2.component.options" :key="option.value" :label="option.value">
                      {{ option.label }}
                    </el-checkbox-button>
                  </template>
                  <template v-else>
                    <el-checkbox v-for="option in item2.component.options" :key="option.value" :label="option.value">
                      {{ option.label }}
                    </el-checkbox>
                  </template>
                </el-checkbox-group>
                <el-select
                  v-else-if="item2.component && item2.component.name === 'el-select'"
                  v-model="scope.row[item2.key]"
                  v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item2.component) : item2.component"
                  @click.native="e => e.stopPropagation()"
                  @change="
                    $emit('cell-data-change', { rowIndex: scope.$index, key: item2.key, value: scope.row[item2.key], row: scope.row })
                  "
                >
                  <el-option v-for="option in handleList(item2.component.options)" :key="option.value" v-bind="option" />
                </el-select>
                <el-cascader
                  v-else-if="item2.component && item2.component.name === 'el-cascader'"
                  v-model="scope.row[item2.key]"
                  v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item2.component) : item2.component"
                  @click.native="e => e.stopPropagation()"
                  @change="
                    $emit('cell-data-change', { rowIndex: scope.$index, key: item2.key, value: scope.row[item2.key], row: scope.row })
                  "
                />
                <el-switch
                  v-else-if="item2.component && item2.component.name === 'el-switch'"
                  v-model="scope.row[item2.key]"
                  v-bind="item2.component"
                  @click.native="e => e.stopPropagation()"
                  @change="
                    $emit('cell-data-change', { rowIndex: scope.$index, key: item2.key, value: scope.row[item2.key], row: scope.row })
                  "
                />
                <el-slider
                  v-else-if="item2.component && item2.component.name === 'el-slider'"
                  v-model="scope.row[item2.key]"
                  v-bind="item2.component"
                  @click.native="e => e.stopPropagation()"
                  @change="
                    $emit('cell-data-change', { rowIndex: scope.$index, key: item2.key, value: scope.row[item2.key], row: scope.row })
                  "
                />
                <el-time-select
                  v-else-if="item2.component && item2.component.name === 'el-time-select'"
                  v-model="scope.row[item2.key]"
                  v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item2.component) : item2.component"
                  @click.native="e => e.stopPropagation()"
                  @change="
                    $emit('cell-data-change', { rowIndex: scope.$index, key: item2.key, value: scope.row[item2.key], row: scope.row })
                  "
                />
                <el-time-picker
                  v-else-if="item2.component && item2.component.name === 'el-time-picker'"
                  v-model="scope.row[item2.key]"
                  v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item2.component) : item2.component"
                  @click.native="e => e.stopPropagation()"
                  @change="
                    $emit('cell-data-change', { rowIndex: scope.$index, key: item2.key, value: scope.row[item2.key], row: scope.row })
                  "
                />
                <apex-date-picker
                  v-else-if="item2.component && item2.component.name === 'el-date-picker'"
                  v-model="scope.row[item2.key]"
                  v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item2.component) : item2.component"
                  @click.native="e => e.stopPropagation()"
                  @change="
                    $emit('cell-data-change', { rowIndex: scope.$index, key: item2.key, value: scope.row[item2.key], row: scope.row })
                  "
                />
                <el-rate
                  v-else-if="item2.component && item2.component.name === 'el-rate'"
                  v-model="scope.row[item2.key]"
                  v-bind="item2.component"
                  @click.native="e => e.stopPropagation()"
                  @change="
                    $emit('cell-data-change', { rowIndex: scope.$index, key: item2.key, value: scope.row[item2.key], row: scope.row })
                  "
                />
                <el-color-picker
                  v-else-if="item2.component && item2.component.name === 'el-color-picker'"
                  v-model="scope.row[item2.key]"
                  v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item2.component) : item2.component"
                  @click.native="e => e.stopPropagation()"
                  @change="
                    $emit('cell-data-change', { rowIndex: scope.$index, key: item2.key, value: scope.row[item2.key], row: scope.row })
                  "
                />
                <render-custom-component
                  v-else-if="item2.component && item2.component.name"
                  v-model="scope.row[item2.key]"
                  :component-name="item2.component.name"
                  :props="item2.component.props ? item2.component.props : null"
                  :scope="scope"
                />
                <render-component
                  v-else-if="item2.component && item2.component.render"
                  :render-function="item2.component.render"
                  :scope="scope"
                />
                <!-- 具名slot -->
                <slot v-else-if="item2.slotName" :name="item2.slotName" :scope="scope" />
                <template v-else>{{
                  item2.formatter
                    ? item2.formatter(scope.row, scope.column, _get(scope.row, item2.key), scope.$index)
                    : _get(scope.row, item2.key)
                }}</template>
              </template>
              <template v-if="item2.children">
                <el-table-column
                  v-for="(item3, index3) in item2.children"
                  :key="index3"
                  :label="handleAttribute(item3.title, '')"
                  :prop="handleAttribute(item3.key, null)"
                  v-bind="item3"
                >
                  <template slot-scope="scope">
                    <el-input
                      v-if="item3.component && item3.component.name === 'el-input'"
                      v-model="scope.row[item3.key]"
                      v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item3.component) : item3.component"
                      @click.native="e => e.stopPropagation()"
                      @keyup.enter.native="item3.component.keyup && item3.component.keyup({ rowIndex: scope.$index, key: item3.key, value: scope.row[item3.key], row: scope.row })"
                      @change="
                        $emit('cell-data-change', { rowIndex: scope.$index, key: item3.key, value: scope.row[item3.key], row: scope.row })
                      "
                    />
                    <el-input-number
                      v-else-if="item3.component && item3.component.name === 'el-input-number'"
                      v-model="scope.row[item3.key]"
                      v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item3.component) : item3.component"
                      @click.native="e => e.stopPropagation()"
                      @change="
                        $emit('cell-data-change', { rowIndex: scope.$index, key: item3.key, value: scope.row[item3.key], row: scope.row })
                      "
                    />
                    <el-radio-group
                      v-else-if="item3.component && item3.component.name === 'el-radio'"
                      v-model="scope.row[item3.key]"
                      v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item3.component) : item3.component"
                      @click.native="e => e.stopPropagation()"
                      @change="
                        $emit('cell-data-change', { rowIndex: scope.$index, key: item3.key, value: scope.row[item3.key], row: scope.row })
                      "
                    >
                      <template v-if="item3.component.buttonMode">
                        <el-radio-button v-for="option in item3.component.options" :key="option.value" :label="option.value">
                          {{ option.label }}
                        </el-radio-button>
                      </template>
                      <template v-else>
                        <el-radio v-for="option in item3.component.options" :key="option.value" :label="option.value">
                          {{ option.label }}
                        </el-radio>
                      </template>
                    </el-radio-group>
                    <el-checkbox
                      v-else-if="item3.component && item3.component.name === 'el-checkbox'"
                      v-model="scope.row[item3.key]"
                      v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item3.component) : item3.component"
                      @click.native="e => e.stopPropagation()"
                      @change="$emit('cell-data-change', { rowIndex: scope.$index, key: item3.key, value: scope.row[item3.key], row: scope.row })"
                    />
                    <el-checkbox-group
                      v-else-if="item3.component && item3.component.name === 'el-checkbox-group'"
                      v-model="scope.row[item3.key]"
                      v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item3.component) : item3.component"
                      @click.native="e => e.stopPropagation()"
                      @change="
                        $emit('cell-data-change', { rowIndex: scope.$index, key: item3.key, value: scope.row[item3.key], row: scope.row })
                      "
                    >
                      <template v-if="item3.component.buttonMode">
                        <el-checkbox-button v-for="option in item3.component.options" :key="option.value" :label="option.value">
                          {{ option.label }}
                        </el-checkbox-button>
                      </template>
                      <template v-else>
                        <el-checkbox v-for="option in item3.component.options" :key="option.value" :label="option.value">
                          {{ option.label }}
                        </el-checkbox>
                      </template>
                    </el-checkbox-group>
                    <el-select
                      v-else-if="item3.component && item3.component.name === 'el-select'"
                      v-model="scope.row[item3.key]"
                      v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item3.component) : item3.component"
                      @click.native="e => e.stopPropagation()"
                      @change="
                        $emit('cell-data-change', { rowIndex: scope.$index, key: item3.key, value: scope.row[item3.key], row: scope.row })
                      "
                    >
                      <el-option v-for="option in handleList(item3.component.options)" :key="option.value" v-bind="option" />
                    </el-select>
                    <el-cascader
                      v-else-if="item3.component && item3.component.name === 'el-cascader'"
                      v-model="scope.row[item3.key]"
                      v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item3.component) : item3.component"
                      @click.native="e => e.stopPropagation()"
                      @change="
                        $emit('cell-data-change', { rowIndex: scope.$index, key: item3.key, value: scope.row[item3.key], row: scope.row })
                      "
                    />
                    <el-switch
                      v-else-if="item3.component && item3.component.name === 'el-switch'"
                      v-model="scope.row[item3.key]"
                      v-bind="item3.component"
                      @click.native="e => e.stopPropagation()"
                      @change="
                        $emit('cell-data-change', { rowIndex: scope.$index, key: item3.key, value: scope.row[item3.key], row: scope.row })
                      "
                    />
                    <el-slider
                      v-else-if="item3.component && item3.component.name === 'el-slider'"
                      v-model="scope.row[item3.key]"
                      v-bind="item3.component"
                      @click.native="e => e.stopPropagation()"
                      @change="
                        $emit('cell-data-change', { rowIndex: scope.$index, key: item3.key, value: scope.row[item3.key], row: scope.row })
                      "
                    />
                    <el-time-select
                      v-else-if="item3.component && item3.component.name === 'el-time-select'"
                      v-model="scope.row[item3.key]"
                      v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item3.component) : item3.component"
                      @click.native="e => e.stopPropagation()"
                      @change="
                        $emit('cell-data-change', { rowIndex: scope.$index, key: item3.key, value: scope.row[item3.key], row: scope.row })
                      "
                    />
                    <el-time-picker
                      v-else-if="item3.component && item3.component.name === 'el-time-picker'"
                      v-model="scope.row[item3.key]"
                      v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item3.component) : item3.component"
                      @click.native="e => e.stopPropagation()"
                      @change="
                        $emit('cell-data-change', { rowIndex: scope.$index, key: item3.key, value: scope.row[item3.key], row: scope.row })
                      "
                    />
                    <apex-date-picker
                      v-else-if="item3.component && item3.component.name === 'el-date-picker'"
                      v-model="scope.row[item3.key]"
                      v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item3.component) : item3.component"
                      @click.native="e => e.stopPropagation()"
                      @change="
                        $emit('cell-data-change', { rowIndex: scope.$index, key: item3.key, value: scope.row[item3.key], row: scope.row })
                      "
                    />
                    <el-rate
                      v-else-if="item3.component && item3.component.name === 'el-rate'"
                      v-model="scope.row[item3.key]"
                      v-bind="item3.component"
                      @click.native="e => e.stopPropagation()"
                      @change="
                        $emit('cell-data-change', { rowIndex: scope.$index, key: item3.key, value: scope.row[item3.key], row: scope.row })
                      "
                    />
                    <el-color-picker
                      v-else-if="item3.component && item3.component.name === 'el-color-picker'"
                      v-model="scope.row[item3.key]"
                      v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item3.component) : item3.component"
                      @click.native="e => e.stopPropagation()"
                      @change="
                        $emit('cell-data-change', { rowIndex: scope.$index, key: item3.key, value: scope.row[item3.key], row: scope.row })
                      "
                    />
                    <render-custom-component
                      v-else-if="item3.component && item3.component.name"
                      v-model="scope.row[item3.key]"
                      :component-name="item3.component.name"
                      :props="item3.component.props ? item3.component.props : null"
                      :scope="scope"
                    />
                    <render-component
                      v-else-if="item3.component && item3.component.render"
                      :render-function="item3.component.render"
                      :scope="scope"
                    />
                    <!-- 具名slot -->
                    <slot v-else-if="item3.slotName" :name="item3.slotName" :scope="scope" />
                    <template v-else>{{
                      item3.formatter
                        ? item3.formatter(scope.row, scope.column, _get(scope.row, item3.key), scope.$index)
                        : _get(scope.row, item3.key)
                    }}</template>
                  </template>
                </el-table-column>
              </template>
            </el-table-column>
          </template>
        </el-table-column>
        <el-table-column v-if="rowHandle" :label="handleAttribute(rowHandle.columnHeader, '操作')" v-bind="rowHandle">
          <template slot-scope="scope">
            <el-button
              v-if="rowHandle.remove && handleRowHandleButtonShow(rowHandle.remove.show, scope.$index, scope.row)"
              :type="handleAttribute(rowHandle.remove.type, 'danger')"
              :disabled="handleRowHandleButtonDisabled(rowHandle.remove.disabled, scope.$index, scope.row)"
              v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, rowHandle.remove) : rowHandle.remove"
              @click.stop="handleRemove(scope.$index, scope.row)"
            >
              {{ handleAttribute(rowHandle.remove.text, "删除") }}
            </el-button>
            <template v-for="(item, index) in handleAttribute(rowHandle.custom, [])">
              <el-button
                v-if="handleRowHandleButtonShow(item.show, scope.$index, scope.row)"
                :key="index"
                :disabled="handleRowHandleButtonDisabled(item.disabled, scope.$index, scope.row)"
                v-bind="$ELEMENT.size ? Object.assign({ size: $ELEMENT.size }, item) : item"
                @click.stop="$emit(item.emit, { index: scope.$index, row: scope.row })"
              >
                {{ item.text }}
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="apexTablePagination">
      <el-pagination
        v-bind="apexTablePagination"
        @size-change="handlePaginationSizeChange"
        @current-change="handlePaginationCurrentChange"
        @prev-click="handlePaginationPrevClick"
        @next-click="handlePaginationNextClick"
      />
    </div>
  </div>
</template>

<script>
import onlyNumber from './directive/only-number'
import base from './mixin/base'
import handleRow from './mixin/handleRow'
import remove from './mixin/remove'
import data from './mixin/data'
import pagination from './mixin/pagination'
import exposeMethods from './mixin/exposeMethods.js'
import utils from './mixin/utils'
import advancedSearch from './mixin/advancedSearch'
import renderComponent from './components/renderComponent.vue'
import renderCustomComponent from './components/renderCustomComponent.vue'
import apexToolbar from './toolbar'
import AdvancedSearch from './toolbar/advanced-search'

export default {
  name: 'ApexTable',
  components: { renderComponent, renderCustomComponent, apexToolbar, AdvancedSearch },
  directives: { onlyNumber },
  mixins: [
    base,
    data,
    handleRow,
    remove,
    pagination,
    exposeMethods,
    utils,
    advancedSearch
  ]
}
</script>

<style>
.sortable-ghost {
  opacity: 0.8;
  color: #fff !important;
  background: #42b983 !important;
}
</style>

<style lang="scss" scoped>
.el-dropdown {
  font-size: inherit;
}
.table-cols-checkboxs {
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  .el-checkbox {
    margin-left: 0;
    & + .el-checkbox {
      margin-top: 12px;
    }
  }
}
// 加上固定高度可防止抖动，但是会产生一系列的问题
// /deep/.el-table {
//   .cell{ height: 34px !important; line-height: 34px; }
// }
.apex-table {
  &.table-header-bgc {
    /deep/ .el-table {
      .el-table__header-wrapper,
      .el-table__fixed,
      .el-table__fixed-right {
        .el-table__header {
          thead tr th {
            color: #333;
            background-color: #efefef;
            border-right: 1px solid #fff;
          }
        }
      }
    }
  }
  .apex-table-header {
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
    margin-top: -6px;
    .operations {
      .el-button {
        margin: 6px 10px 0 0;
      }
    }
    .toolbar {
      align-self: flex-end;
      .aepx-table-toolbar {
        display: flex;
        align-items: center;
      }
    }
    & + .apex-table-body {
      padding-top: 0px !important;
    }
  }
  .apex-advanced-search {
    & + .apex-table-body {
      padding-top: 0px !important;
    }
  }
  .apex-table-body {
    padding: 15px 0;
    overflow: hidden;
    /deep/ .el-table {
      .el-table__header-wrapper,
      .el-table__fixed,
      .el-table__fixed-right {
        .el-table__header {
          thead {
            tr {
              th {
                .cell {
                  .el-input,
                  .el-select,
                  .el-date-editor {
                    width: 100%;
                    & ~ .caret-wrapper {
                      position: absolute;
                      top: -6px;
                      right: 4px;
                      & + .el-table__column-filter-trigger {
                        position: absolute;
                        top: -6px;
                        right: 30px;
                      }
                    }
                    & ~ .el-table__column-filter-trigger {
                      position: absolute;
                      top: -6px;
                      right: 10px;
                    }
                  }
                  .apex-table-header-slot,
                  .apex-table-header-begin-end-date {
                    display: flex;
                    align-items: center;
                    > span {
                      padding: 0 3px;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .el-table__body {
        .el-table__row {
          .cell {
            .el-radio {
              .el-radio__label {
                display: none;
              }
            }
          }
        }
        tr:hover > td {
          background-color: #f5f7fa;
        }
        .el-table__expanded-cell {
          padding: 5px 48px;
        }
        .checked-row-wh > td {
          color: #fff !important;
          background: #42b983 !important;
        }
      }
      .el-table-column--selection {
        > .cell {
          padding-left: 14px;
          padding-right: 14px;
        }
      }
    }
  }
}
</style>
